import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Row, Col, Typography, Space} from 'antd';
import { fetchWebAssetsList } from '../../api/assetsApi';
import Gallery3d  from "../../components/ThreeDimensional/Gallery3d";
import {HOSTNAME } from '../../configs/Domain';

const formatUrl = (passthroughUrl)=>{
    return `${HOSTNAME}/assets/proxy-image?url=${passthroughUrl}`
}

const TimeCovers = ({ assetKey }) => {
  const dispatch = useDispatch();

  const assetList = useSelector((state) => state.assets.assetLists[assetKey] || []);
  const loading = useSelector((state) => state.assets.loading[assetKey]);
  const error = useSelector((state) => state.assets.errors[assetKey]);

  const [selectedObject, setSelectedObject] = useState(null);

  useEffect(() => {
    dispatch(fetchWebAssetsList({ assetKey }));
  }, [dispatch, assetKey]);




  const formattedItems = useMemo(()=>{
      if (!assetList) return []
        return [...assetList].map(x=>({
            imgUrl: formatUrl(x.img_url),
            onClick: ()=>setSelectedObject(x)

        }))
    }, [assetList])

  if (loading) return <p>Loading {assetKey}...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
      <div>
          {selectedObject &&<Row>
              <Typography.Title level={3}>{selectedObject.title}</Typography.Title>
          </Row>}
          <Gallery3d items={formattedItems} />
      </div>
  );
};

export default TimeCovers;
